import "lightbox2/dist/css/lightbox.min.css";
import "./style.scss";

window.$ = require('jquery');
window.lightbox = require('lightbox2');

$(() => {
  /*
    var $hero = $(".hero");
    if($hero.length > 0) {
      var count = 0;
      var change_bg = () => {
        let src = "";
        if( count == 0 ) {
          src = "/assets/img/top-bg.jpg";
        } else {
          src = "/_temp/top-bg" + count + ".jpg";
        }
        $hero.css("backgroundImage", "url(" + src + ")");
        count++;
        if( count > 3 ) count = 0;
      };
      change_bg();
      setInterval( change_bg, 3000 );
    }
    */

  $(".wpuf-dashboard-content > .wpuf-form-add").prepend("<h2>カーリペアの新規ご依頼</h2><p>カーリペアのご依頼はこちらのフォームをご利用ください。ご依頼いただいた後からでも追加修正可能です。</p>");
  $(".wpuf-dashboard-navigation ul li:first-child").on("click", (e) => {
    location.href = e.target.getAttribute("href");
  });

  // コメント出力（添付ファイル処理）
  $(".dco-image-attachment").each(function(ind, elm) {
    let $this = $(this);
    let $img = $this.children("img");
    let src = $img.attr("src");
    $img.wrap('<a href="' + src + '" data-lightbox="dco"></a>');
  });
  $(".dco-misc-attachment a").attr("target", "_blank");

  // コメントフォームの添付対応
  $("#commentform").attr("enctype", "multipart/form-data").on("submit", () => {
    let $msg = $("#comment");
    if ($msg.val() == "") {
      $("#comment-form-error").addClass("show");
      return false;
    }
  });

  // 投稿編集フォームで、「ステータス」の処理（値引継ぎのみ）
  let $order_edit_form = $(".submit-post.edit form");
  if ($order_edit_form.length > 0) {
    if (typeof my_post_status != "undefined" && my_post_status != "") {
      $order_edit_form.append('<input type="hidden" name="order-status" value="' + my_post_status + '">');
    }
  }

  // SPメニュー時の固定処理
  $(".menu-trigger").on("click", () => {
    let checked = $("#primary-navigation-checkbox").is(":checked");
    if (checked) {
      $("body").removeClass("fixed");
    } else {
      $("body").addClass("fixed");
    }
  });

  // 製品一覧ページ 画像切り替え処理
  $(".js-hover-image").each((ind, elm) => {
    let $this = $(elm);
    let $img = $this.children("img");
    if ($img.length > 0) {
      let src = $img.attr("src");
      let dest = src.replace(/^(.+\/[a-z]+[0-9]\-)[0-9]+(\.[a-zA-Z]{3,4})$/, "$12$2");
      $this.on("mouseover", () => {
        $img.attr("src", dest);
      });
      $this.on("mouseout", () => {
        $img.attr("src", src);
      });
    }
  });

  // FAQ
  $(".faq dt").each((ind, elm) => {
    let $this = $(elm);
    let $dd = $this.next("dd");
    $dd.slideUp();
    $this.on("click", () => {
      if ($this.hasClass("active")) {
        $this.removeClass("active");
        $dd.slideUp();
      } else {
        $this.addClass("active");
        $dd.slideDown();
      }
    });
  });

  $(".js-form-reset").on("click", function(e) {
    e.preventDefault();
    let $form = $(this).parents("form");
    $form.find("input:text, select").each(function(ind, elm) {
      elm.value = "";
    });
    $form.trigger("submit");
  });

  $(".js-select").on("change", function() {
    let selectedValue = $(this).val();
    if (selectedValue != "") $(this).css("color", "rgb(38, 37, 51)");
    else $(this).css("color", "#CCC");

    // 投稿者絞込み
    if ($(this).hasClass("js-next-select")) {
      let target = "#" + $(this).data("target");
      let $target = $(target);
      let val = $(this).val();
      $target.children("option").each(function(ind, elm) {
        if ($(this).val() == "" || $(this).data("id") == val) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  }).trigger("change");

  // lightbox option設定
  lightbox.option({
    'fitImagesInViewport': false,
    'maxWidth': window.innerWidth - 50,
    'maxHeight': window.innerHeight - 100
  });

  // twitterのフォローボタン
  $(".js-anim-gif").on("mouseover", function() {
    let src = $(this).attr("src");
    $(this).attr("src", src.replace(/(.+)\.[a-z]{3,4}/, "$1.gif"));
  }).on("mouseout", function() {
    let org = $(this).data("org");
    let src = $(this).attr("src");
    $(this).attr("src", src.replace(/(.+)\.[a-z]{3,4}/, "$1." + org));
  });
});